import { Modal } from "react-bootstrap";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  @media (min-width: 50rem) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 70rem) {
    grid-template-columns: repeat(2 1fr);
  }
`;

const GridColumn = styled.section``;
const GridColumnTitle = styled.h1.attrs(() => ({
  className: "mabry-medium",
}))`
  font-size: 1.125rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;
const GridColumnContent = styled.div`
  img {
    max-width: 100%;
  }
`;

const HelpText = styled.span`
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  display: block;
`;

export default {
  ...Modal,
  Grid,
  GridColumn,
  GridColumnTitle,
  GridColumnContent,
  HelpText,
};
